import Axios from '@/lib/request'
const LOP_SRT = `?LOP-DN=${process.env.VUE_APP_GW_DOMAIN_HTTP}`
const LOP_SRT_JSF = `?LOP-DN=${process.env.VUE_APP_GW_DOMAIN}`

const TASKAPI = {
  getTaskCount: () => Axios.post(`${process.env.VUE_APP_GW_HOST_PRE}taskHubWs/refresh${LOP_SRT}`, {}),
  setTaskCount: (params: any) => Axios.post(`${process.env.VUE_APP_GW_HOST_PRE}/taskHubWs/createTaskHub${LOP_SRT}`, params),
  queryRoadAreaBySiteCode: (params: any) => Axios.post(`/siteBasic/api/site/queryRoadAreaBySiteCode${LOP_SRT_JSF}`, params),
  queryCourierInformationBySiteCode: (params: any) => Axios.post(`/inSite/queryCourierInformationBySiteCode${LOP_SRT_JSF}`, params),
  getSiteRoadFences: (params: any) => Axios.post(`/siteBasic/getSiteRoadFences${LOP_SRT_JSF}`, params),
  // 获取司机实时位置
  queryCurrentLocation: (params: any) => Axios.post(`/siteBasic/queryCurrentLocation${LOP_SRT_JSF}`, params),
  batchQueryCurrentLocation: (params: any) => Axios.post(`/operation/queryCourierTaskLocationForDriverMap${LOP_SRT_JSF}`, params)

  // batchQueryCurrentLocation: (params: any) => Axios.post(`/siteBasic/batchQueryCurrentLocation${LOP_SRT_JSF}`, params)
}

export default TASKAPI
